// Text with the server's highlight ranges ([start, end) in this same text)
// marked. The server places them: it folds Arabic the way the search does,
// so "اجمالي" marks "إجمالي" (backend/chainlit/admin_search.py).

export function Highlight({
  text,
  ranges
}: {
  text: string;
  ranges?: [number, number][] | null;
}) {
  if (!ranges || ranges.length === 0) return <>{text}</>;
  const parts: JSX.Element[] = [];
  let at = 0;
  ranges.forEach(([s, e], i) => {
    if (s < at || s >= text.length) return;
    if (s > at) parts.push(<span key={`t${i}`}>{text.slice(at, s)}</span>);
    parts.push(
      <mark
        key={`m${i}`}
        className="rounded-sm bg-amber-200/80 px-0.5 text-foreground dark:bg-amber-500/40"
      >
        {text.slice(s, e)}
      </mark>
    );
    at = e;
  });
  if (at < text.length) parts.push(<span key="end">{text.slice(at)}</span>);
  return <>{parts}</>;
}
